/**
 * Header Layout
 *
 * @file header.js
 */

import $ from 'jquery';

const header = (() => {

  const fullMenu = () => {

    // $("header .main-nav ul li.main-nav__item").hover(function(){
    //   $(".mega-menu").removeClass("active");
    //   $(this).find(".mega-menu").addClass("active");
    //   if($(this).find(".mega-menu").is(":visible" )){
    //     // $("body").addClass("hidden");
    //     $("header .main-nav a").removeClass("hover");
    //     $(this).children("a").addClass("hover");
    //     $("header").addClass("full-menu-show");
    //     $(".full-header-bg").addClass("active");
    //   } else{
    //     // $("body").removeClass("hidden");
    //     $("header .main-nav a").removeClass("hover");
    //     $("header").addClass("full-menu-show");
    //     $(".full-header-bg").removeClass("active");
    //   }
    // },function(){
    //   $("header").removeClass("full-menu-show");
    //   $(".full-header-bg").removeClass("active");
    //   $(".mega-menu").removeClass("active");
    // });
    if($(window).width() > 992 ){
      $("header .main-nav ul li.main-nav__item").hover(function(){
        $("header").addClass("hover-menu");
      },function(){
        $("header").removeClass("hover-menu");
      });
    } else{
      $("header").addClass("hover-menu");
    }
    $("header .main-nav ul li.main-nav__item").on("click", function(){
      $(".mega-menu").removeClass("active");
      $(this).find(".mega-menu").addClass("active");
      if($(this).find(".mega-menu").is(":visible" )){
        $("header .main-nav a").removeClass("hover");
        $(this).children("a").addClass("hover");
        $("header").addClass("full-menu-show");
        $(".full-header-bg").addClass("active");
      } else{
        $("header .main-nav a").removeClass("hover");
        $("header").removeClass("full-menu-show");
        $(".full-header-bg").removeClass("active");
      }
    });
    
    // $("header .main-nav ul li .main-nav__link").hover(function(){
    //   $("header").addClass("full-menu-show");
    // },function(){
    //   $("header").removeClass("full-menu-show");
    // });
    $("header .main-nav ul li .main-nav__link").on("click", function(){
      $("header").addClass("full-menu-show");
    });
    $("header").on('mouseleave', '.full-header-bg', function(e) {
      $("header").removeClass("full-menu-show");
      // $("header .header-menu").removeClass("active");
    });
    $(".full-header-bg").on('mouseenter', ".mega-menu",  function(e) {
      $("header").addClass("full-menu-show");
      // $("header .header-menu").removeClass("active");
    });
    $(".mega-menu").on('mouseenter',function(e) {
      $("header").addClass("full-menu-show");
      // $("header .header-menu").removeClass("active");
    });
    $(".full-header-bg").on("click", function(){
      // $("body").removeClass("hidden");
      $("header .main-nav a").removeClass("hover");
      $("header").removeClass("full-menu-show");
      $(".mega-menu").removeClass("active");
      $(".full-header-bg").removeClass("active");
    });
    $(".fl-menu .fs ul li").hover(function() {
      $(".fl-menu .fs ul li a").addClass("opacity");
      $(this).find("a").removeClass("opacity");
    }, function(){
      $(".fl-menu .fs ul li a").removeClass("opacity");
    });
    // function menuChange() {
      
    //   $("header .main-nav a").mouseenter(function(){
    //     var tb = $(this).attr("data-sub-menu");
    //     if($(this).attr("data-sub-menu")){
    //       $("header .main-nav a").removeClass("hovers");
    //       $(this).addClass("hovers");
    //       $("header").addClass("full-menu-show");
    //       // $("header .header-menu").removeClass("active");
    //       // $("header .header-menu[data-main-menu="+ tb +"]").addClass("active");
    //     } else{
    //       $("header .main-nav a").removeClass("hovers");
    //       $("header").removeClass("full-menu-show");
    //       // $("header .header-menu").removeClass("active");
    //     }
    //   });
    // }
    // $("header .main-nav a").hover(function(){
    //   $("header").addClass("hv-a-tag");
    // }, function(){
    //   $("header").removeClass("hv-a-tag");
    // });
    // $("header").on('mouseenter', '.header-menu, .main-nav', function(e) {
    //   console.log(e.currentTarget.classList)
    //   if(e.currentTarget.classList == "main-nav"){
    //     menuChange();
    //   } else {
    //     menuChange();
    //   }
    // });
    // $("header").on('mouseleave', '.header-menu', function(e) {
    //   $("header").removeClass("full-menu-show");
    //   // $("header .header-menu").removeClass("active");
    // });
    // $("header .main-nav").mouseleave(function(e){
    //   $("header .header-menu").stop().removeClass("active");
    //   $("header").stop().removeClass("full-menu-show");
    // });
    // $("header").mouseleave(function(){
    //   $("header").removeClass("full-menu-show");
    // });
    // $("header .header-menu").mouseenter(function(){
    //   $("header").stop().addClass("full-menu-show");
    // });
  };

  const mobileMenu = () => {
    $(".mobile-menu-arrow").on("click", function(){
      $(this).toggleClass("active");
      $(".header-right").toggleClass("active");
      $("body").toggleClass("hidden");
    });
  };
  

  const fullSearch = () => {
    $("header .search, .mobile-search").on("click", function(){
      $(".full-search").toggleClass("active");
      $("html").toggleClass("hidden");
      setTimeout(() => {
        $(".full-search input").focus();
      }, "500");
    });
    $(".full-search .bg, .full-search-close").on("click", function(){
      $(".full-search").removeClass("active");
      $("html").removeClass("hidden");
      setTimeout(() => {
        $(".full-search input").blur();
      }, "500");
    });
  };

  const fixedHeader = () => {
    var offset = $("header").offset();
     checkOffset();

     $(window).scroll(function() {
         checkOffset();
     });

     function checkOffset() {
         if ( $(window).scrollTop() >= 115){
             $('header').addClass('fixed-header');
         } else {
             $('header').removeClass('fixed-header');
         } 
     }
  };

  const init = () => {
    fixedHeader();
    fullMenu();
    mobileMenu();
    fullSearch();
  };

  return {
    init,
  };
})();

export default header;
